// Redux/Slices/themeSlice.js
import { createSlice } from '@reduxjs/toolkit';


const initialState = {
  mode: 'light', // default value only here
};

const themeSlice = createSlice({
  name: 'theme',
  initialState,
  reducers: {
    toggleTheme: (state) => {
      state.mode = state.mode === 'light' ? 'dark' : 'light';
    },
    setTheme: (state, action) => {
      state.mode = action.payload;
    },
    resetTheme: (state) => {
      state.mode = 'light';
    },
  },
});

export const { toggleTheme, setTheme, resetTheme } = themeSlice.actions;
export default themeSlice.reducer;
